// src/components/account/SettingsTab.tsx

import React from 'react';

const SettingsTab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-2xl shadow-sm p-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Account Settings</h2>

        <div className="space-y-6">
          {/* Change Password Section */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Change Password</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Current Password</label>
                <input
                  type="password"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-teal-500 focus:outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">New Password</label>
                <input
                  type="password"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-teal-500 focus:outline-none"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Confirm New Password</label>
                <input
                  type="password"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:border-teal-500 focus:outline-none"
                />
              </div>
              <button className="px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap">
                Update Password
              </button>
            </div>
          </div>

          {/* Email Notifications Section */}
          <div className="pt-6 border-t border-gray-200">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Email Notifications</h3>
            <div className="space-y-3">
              <label className="flex items-center cursor-pointer">
                <input type="checkbox" defaultChecked className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500 cursor-pointer" />
                <span className="ml-3 text-gray-700">New reviews on my listings</span>
              </label>
              <label className="flex items-center cursor-pointer">
                <input type="checkbox" defaultChecked className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500 cursor-pointer" />
                <span className="ml-3 text-gray-700">Weekly performance reports</span>
              </label>
              <label className="flex items-center cursor-pointer">
                <input type="checkbox" className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500 cursor-pointer" />
                <span className="ml-3 text-gray-700">Marketing and promotional emails</span>
              </label>
            </div>
          </div>

          {/* Danger Zone Section */}
          <div className="pt-6 border-t border-gray-200">
            <h3 className="text-lg font-semibold text-red-600 mb-4">Danger Zone</h3>
            <button className="px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap">
              Deactivate Account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsTab;